<template>
  <div class="box">
    <div class="role">
      <div class="role-item" v-for="item of list" :key="item.id">
        <div class="left">
          <img v-lazy="`${item.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`" />
          <div class="info">
            <span class="name">{{item.nickName}}</span>
            <span class="message">{{item.newMessageCount}}条未读消息</span>
          </div>
        </div>
        <div v-if="item.logined" class="current-role">当前角色</div>
        <div v-else @click="switchRole(item)" class="right">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E5%88%87%E6%8D%A2.svg" alt />
          <div class="button">切换</div>
        </div>
      </div>
    </div>
    <div @click="judgeAddRole" class="footer">
      <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%2B.svg" />
      <span>新建角色</span>
    </div>
    <AddRole :show="show" @close="show=false" />
  </div>
</template>
<script>
import AddRole from '../../../components/addRole'
import { get, post } from '../../../utils/request'
import { set, get as getUser } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
import { Toast } from 'vant'
const { mapActions } = createNamespacedHelpers('user')
export default {
  components: {
    AddRole
  },
  data () {
    return {
      show: false,
      list: [],
      isShow: false
    }
  },
  created () {
    this.getRoleList()
  },
  methods: {
    judgeAddRole () {
      const user = getUser('user')
      if (!user || !user.isAllowAddRole) {
        Toast.fail('没有添加角色权限!')
        return
      }
      this.show = true
    },
    ...mapActions({
      updateUserAvater: 'updateUserAvater',
      updateUserNickName: 'updateUserNickName'
    }),
    getRoleList () {
      const user = getUser('user')
      const promise = get({
        url: `/user/listRole/${user.phoneNumber}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.list = detail
        }
      })
    },
    switchRole (item) {
      const user = getUser('user')
      const promise = post({
        url: '/user/checkoutRole',
        data: {
          phoneNumber: user.phoneNumber,
          role_id: item.id
        }
      })
      promise.then(res => {
        const {
          data: { code }
        } = res
        if (Object.is(code, 200)) {
          user.id = item.id
          user.avatar = item.avatar
          user.nickName = item.nickName
          this.updateUserAvater(item.avatar)
          this.updateUserNickName(item.nickName)
          set('user', user)
          this.getRoleList()
          Toast.success('角色切换成功')
        }
      })
    }
  },
  watch: {
    show (val) {
      if (!val) {
        this.getRoleList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  margin-top: 16px;
  padding: 0 16px;
  height: calc(100% - 16px);
  box-sizing: border-box;
  .role {
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: scroll;
    .role-item {
      width: 100%;
      height: 68px;
      background: rgba(255, 255, 255, 1);
      border-bottom: 1px solid #f5f5f5;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: inline-block;
          margin-right: 6px;
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 36px;
          .name {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
          }
          .message {
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(60, 60, 67, 0.6);
            line-height: 12px;
          }
        }
      }
      .right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 100%;
        box-sizing: border-box;
        img {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 7px;
        }
        .button {
          background: rgba(255, 255, 255, 1);
          border-radius: 8px;
          border: none;
          outline: none;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(87, 107, 148, 1);
        }
      }
      .current-role {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
      }
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.04);
    z-index: 999;
    img {
      width: 14px;
      height: 14px;
      display: inline-block;
      margin-right: 6px;
    }
    span {
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
    }
  }
}
</style>
